import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.25 1.75H4.75A3.754 3.754 0 0 0 1 5.5v9a3.754 3.754 0 0 0 3.75 3.75h10.5A3.754 3.754 0 0 0 19 14.5v-9a3.754 3.754 0 0 0-3.75-3.75M17.5 14.5c0 1.24-1.01 2.25-2.25 2.25H4.75c-1.24 0-2.25-1.01-2.25-2.25v-9c0-1.24 1.01-2.25 2.25-2.25h10.5c1.24 0 2.25 1.01 2.25 2.25zm-2.25-8.25a.75.75 0 0 1-.75.75H9.25a.75.75 0 0 1 0-1.5h5.25a.75.75 0 0 1 .75.75M7 6.25a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0M15.25 10a.75.75 0 0 1-.75.75H9.25a.75.75 0 0 1 0-1.5h5.25a.75.75 0 0 1 .75.75M7 10a1.125 1.125 0 1 1-2.25 0A1.125 1.125 0 0 1 7 10m8.25 3.75a.75.75 0 0 1-.75.75H9.25a.75.75 0 0 1 0-1.5h5.25a.75.75 0 0 1 .75.75m-8.25 0a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0"
    }, null, -1)
  ]))]))
}
export default { render: render }